import { ModuleDefinition } from '../types/cms.types';

// Định nghĩa các modules và permissions mặc định trong hệ thống
export const SYSTEM_MODULES: ModuleDefinition[] = [
    {
        name: 'dashboard',
        displayName: 'Dashboard',
        defaultPermissions: {
            view: true,
            add: false,
            edit: false,
            delete: false
        }
    },
    {
        name: 'trip_management',
        displayName: 'Quản lý chuyến đi',
        subModules: [
            {
                name: 'trip_list',
                displayName: 'Danh sách chuyến đi',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: false
                }
            }
        ],
        defaultPermissions: {
            view: true,
            add: true,
            edit: true,
            delete: false
        }
    },
    {
        name: 'driver_management',
        displayName: 'Quản lý tài xế',
        subModules: [

            {
                name: 'drivers',
                displayName: 'Quản lí tài xế',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: false
                }
            }
        ],
        defaultPermissions: {
            view: true,
            add: true,
            edit: true,
            delete: false
        }
    },
    {
        name: 'user_management',
        displayName: 'Quản lý người dùng',
        subModules: [
            {
                name: 'user_list',
                displayName: 'Danh sách người dùng',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: false
                }
            }
        ],
        defaultPermissions: {
            view: true,
            add: true,
            edit: true,
            delete: false
        }
    },
    {
        name: 'notification_management',
        displayName: 'Quản lý thông báo',
        subModules: [
            {
                name: 'notification_list',
                displayName: 'Danh sách thông báo',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            }
        ],
        defaultPermissions: {
            view: true,
            add: true,
            edit: true,
            delete: true
        }
    },
    {
        name: 'voucher_management',
        displayName: 'Quản lý Voucher',
        subModules: [
            {
                name: 'vouchers_public',
                displayName: 'Voucher chung',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            },
            {
                name: 'vouchers_private',
                displayName: 'Voucher riêng',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            },
            {
                name: 'vouchers_random_code',
                displayName: 'Voucher mã ngẫu nhiên',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            },
            {
                name: 'vouchers_reward',
                displayName: 'Voucher đổi điểm',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            }
        ],
        defaultPermissions: {
            view: true,
            add: true,
            edit: true,
            delete: true
        }
    },
    {
        name: 'permission_management',
        displayName: 'Quản lý phân quyền',
        subModules: [
            {
                name: 'role_management',
                displayName: 'Quản lý vai trò',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            },
            {
                name: 'permission_list',
                displayName: 'Danh sách quyền',
                defaultPermissions: {
                    view: true,
                    add: false,
                    edit: false,
                    delete: false
                }
            }
        ],
        defaultPermissions: {
            view: true,
            add: true,
            edit: true,
            delete: true
        }
    },
    {
        name: 'admin_management',
        displayName: 'Quản lý admin',
        subModules: [
            {
                name: 'admin_list',
                displayName: 'Danh sách admin',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            }
        ],
        defaultPermissions: {
            view: true,
            add: true,
            edit: true,
            delete: true
        }
    },
    {
        name: 'pricing_management',
        displayName: 'Quản lý giá cả',
        subModules: [
            {
                name: 'pricing_motobike',
                displayName: 'Giá xe máy',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            },
            {
                name: 'pricing_car_4',
                displayName: 'Giá xe ô tô 4 chỗ',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            },
            {
                name: 'pricing_car_7',
                displayName: 'Giá xe ô tô 7 chỗ',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            }

        ],
        defaultPermissions: {
            view: true,
            add: true,
            edit: true,
            delete: true
        }
    },
    {
        name: 'news-banners-management',
        displayName: 'Tin tức - Banners',
        subModules: [
            {
                name: 'banners-management',
                displayName: 'Danh sách banners',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            },
            {
                name: 'news_management',
                displayName: 'Danh sách tin tức',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            }
        ],
        defaultPermissions: {
            view: true,
            add: true,
            edit: true,
            delete: true
        }
    },
    {
        name: 'system_management',
        displayName: 'Quản lý hệ thống',
        subModules: [
            {
                name: 'system_configuration',
                displayName: 'Cấu hình hệ thống',
                defaultPermissions: {
                    view: true,
                    add: true,
                    edit: true,
                    delete: true
                }
            }
        ],
        defaultPermissions: {
            view: true,
            add: true,
            edit: true,
            delete: true
        }
    }
];

// Các vai trò mặc định
export const DEFAULT_ROLES = [
    {
        name: 'Super Admin',
        description: 'Có toàn quyền trên hệ thống',
        permissions: 'all' // Sẽ được xử lý đặc biệt để có tất cả quyền
    },
    {
        name: 'Admin',
        description: 'Quản trị viên có quyền quản lý hầu hết các chức năng',
        excludeModules: ['admin_management'] // Loại trừ module quản lý admin
    },
    {
        name: 'Content Manager',
        description: 'Quản lý nội dung - có quyền quản lý voucher, thông báo',
        includeModules: [
            'dashboard',
            'voucher_management',
            'notification_management'
        ]
    },
    {
        name: 'Trip Manager',
        description: 'Quản lý chuyến đi và tài xế',
        includeModules: [
            'dashboard',
            'trip_management',
            'driver_management',
            'user_management'
        ]
    },
    {
        name: 'Moderator',
        description: 'Kiểm duyệt viên có quyền moderate content và user',
        includeModules: [
            'dashboard',
            'trip_management',
            'driver_management',
            'user_management',
            'notification_management'
        ],
        restrictPermissions: {
            delete: false
        }
    },
    {
        name: 'Operator',
        description: 'Nhân viên vận hành chỉ có quyền xem và chỉnh sửa cơ bản',
        includeModules: [
            'dashboard',
            'trip_management',
            'driver_management'
        ],
        restrictPermissions: {
            add: false,
            delete: false
        }
    },
    {
        name: 'Viewer',
        description: 'Chỉ có quyền xem các thông tin cơ bản',
        includeModules: [
            'dashboard',
            'trip_management',
            'driver_management',
            'user_management'
        ],
        restrictPermissions: {
            add: false,
            edit: false,
            delete: false
        }
    }
];

// Hàm helper để tạo permissions từ config
export const generatePermissionsFromRole = (roleConfig: any): any[] => {
    const permissions: any[] = [];

    for (const module of SYSTEM_MODULES) {
        // Nếu role có tất cả quyền
        if (roleConfig.permissions === 'all') {
            // Thêm quyền cho module chính
            permissions.push({
                module_name: module.name,
                view_permission: true,
                add_permission: true,
                edit_permission: true,
                delete_permission: true
            });

            // Thêm quyền cho sub modules
            if (module.subModules) {
                for (const subModule of module.subModules) {
                    permissions.push({
                        module_name: module.name,
                        sub_module_name: subModule.name,
                        view_permission: true,
                        add_permission: true,
                        edit_permission: true,
                        delete_permission: true
                    });
                }
            }
            continue;
        }

        // Kiểm tra exclude modules
        if (roleConfig.excludeModules && roleConfig.excludeModules.includes(module.name)) {
            continue;
        }

        // Kiểm tra include modules
        if (roleConfig.includeModules && !roleConfig.includeModules.includes(module.name)) {
            continue;
        }

        // Tạo permissions với restrict nếu có
        const modulePermissions = {
            view_permission: roleConfig.restrictPermissions?.view ?? module.defaultPermissions.view,
            add_permission: roleConfig.restrictPermissions?.add ?? module.defaultPermissions.add,
            edit_permission: roleConfig.restrictPermissions?.edit ?? module.defaultPermissions.edit,
            delete_permission: roleConfig.restrictPermissions?.delete ?? module.defaultPermissions.delete
        };

        // Thêm quyền cho module chính
        permissions.push({
            module_name: module.name,
            ...modulePermissions
        });

        // Thêm quyền cho sub modules
        if (module.subModules) {
            for (const subModule of module.subModules) {
                const subModulePermissions = {
                    view_permission: roleConfig.restrictPermissions?.view ?? subModule.defaultPermissions.view,
                    add_permission: roleConfig.restrictPermissions?.add ?? subModule.defaultPermissions.add,
                    edit_permission: roleConfig.restrictPermissions?.edit ?? subModule.defaultPermissions.edit,
                    delete_permission: roleConfig.restrictPermissions?.delete ?? subModule.defaultPermissions.delete
                };

                permissions.push({
                    module_name: module.name,
                    sub_module_name: subModule.name,
                    ...subModulePermissions
                });
            }
        }
    }

    return permissions;
};
